import React from 'react';
import './ZhTitleComponent.scss';
import history from '../../router/history';

class ZhTitleComponent extends React.Component {
	goBack() {
		let outArr = ['/index']
		const pathname = history.location.pathname
		if (pathname.includes('/result')) {
			history.replace('/index')
			return
		}
		if (outArr.includes(pathname)) {
			console.log('我要触发中行的返回')
			try {
				window.c_plugins.merchantBridge.goToNative(function () {
				}, function (err) {
				}, {page: '0'})
			} catch (e) {
			}
		} else {
			history.goBack()
		}
	}

	render() {
		return (
			<div>
				<div className="top-head-zh">
					<div className="btn-warp">
						<img
							className="close-btn"
							src={require('../../asstes/img/Index/zh-arrow-left.png')}
							onClick={() => this.goBack()}
							alt=""
						/>
					</div>
					<div className="title">{this.props.title || '锦盒送福运'}</div>
					<div className="right"></div>
				</div>
				<div className="top-bar"></div>
			</div>
		)
	}
}

export default ZhTitleComponent;
